import classNames from 'classnames';
import { FC, useCallback, useMemo } from 'react';

import { handleKeyboardSelect } from '../../helpers/Accessibility';
import DateTime from '../../helpers/DateTime';
import style from './DateButton.module.scss';

interface DateButtonProps {
  disabled?: boolean;
  onSelect: (slot: string) => void;
  selected?: boolean;
  slot: string;
}

export const DateButton: FC<DateButtonProps> = ({
  slot,
  selected,
  disabled,
  onSelect,
}) => {
  const buttonClassNames = classNames({
    [style.btnDate]: true,
    ['partner-initial-border-color']: selected && !disabled,
    [style.btnDateDisabled]: disabled,
  });

  const dayOfWeek = `${DateTime.formatDate('EEEEEE', new Date(slot))} `;
  const day = `${DateTime.formatDate('d MMM', new Date(slot))} `;

  const onClick = useCallback(() => {
    if (disabled) return;
    onSelect(slot);
  }, [onSelect, disabled, slot]);

  const handleKeyDown = useMemo(() => handleKeyboardSelect(onClick), [onClick]);

  return (
    <button
      aria-current={selected ? 'date' : false}
      aria-disabled={disabled}
      aria-label={DateTime.formatDate('EEEE, do MMMM', new Date(slot))}
      className={buttonClassNames}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={!disabled ? 0 : undefined}
    >
      <span>{dayOfWeek}</span>
      <span>{day}</span>
    </button>
  );
};
